export default "__VITE_ASSET__DOcYIzgz__"